import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { doc, getDoc } from "firebase/firestore";
import db from "../../config/firebase";
import { PromoImage } from "../../models/promo-image";

// Async thunk to fetch promo images
export const fetchPromoImages = createAsyncThunk(
  "promo/fetchImages",
  async () => {
    // Access the document directly
    const promoDoc = doc(db, "admin/promo");
    const snapshot = await getDoc(promoDoc);

    if (snapshot.exists()) {
      const data = snapshot.data();
      return (data.imagesList || []) as PromoImage[];
    } else {
      throw new Error("Promo document not found");
    }
  }
);

const promoSlice = createSlice({
  name: "promo",
  initialState: {
    images: [] as PromoImage[],
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPromoImages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPromoImages.fulfilled, (state, action) => {
        state.images = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPromoImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch promo images";
      });
  },
});

export default promoSlice.reducer;
